'use client'

import { isDebugMode } from '@/lib/utils'

declare global {
  interface Window {
    twq: (type: 'event' | 'config', eventId: string, params?: Record<string, any>) => void
  }
}

export type XPixelEventId = string

export interface XPixelPurchaseParams {
  value?: number
  currency?: string
  contents?: Array<{
    content_type?: string
    content_id?: string
    content_name?: string
    content_price?: number
    num_items?: number
    content_group_id?: string
  }>
  conversion_id?: string
  email_address?: string
}

export const xPixel = (eventId: XPixelEventId, params?: XPixelPurchaseParams) => {
  if (isDebugMode()) {
    console.log(`🐦 X Pixel Event: ${eventId}`, params)
  }

  if (typeof window !== 'undefined' && window.twq) {
    window.twq('event', eventId, params || {})
  }
}
